import React, { useEffect } from 'react';
import styled from 'styled-components';
import oh from 'output-helpers';

const Container = styled.div``;

export default () => {
    useEffect(() => {
        localStorage.clear();

        const params = new URLSearchParams(document.location.search);
        const returnUrl = params ? params.get('returnUrl') : null;
        if (returnUrl) {
          window.location.href = returnUrl;
          return;
        }

        if (document.location.pathname.includes('/v2')) {
            document.location.href = '/v2';
        } else {
            document.location.href = '/';
        }
    }, []);
    return <Container>{oh.translate('logging_out')}</Container>;
};



// WEBPACK FOOTER //
// ./src/views/Logout.tsx